import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';
import { Loader } from 'hfs-common-ui';
import * as queryHelper from '~/utils/query-helper/query-helper';
import { useDeleteUptimeTokenMutation } from '../api/uptime-api';
import { composeUptimeLogoutUrl } from '../utils/utils';
import * as S from './styled';

const UptimeLogoutContainer = () => {
  const { search } = useLocation();
  const returnUrl = useMemo(
    () =>
      queryHelper.getValueFromQueryString(search, 'returnUrl') ??
      process.env.UPTIME_HOMEPAGE ??
      '/',
    [search]
  );
  const [deleteUptimeToken, { isSuccess, isError }] = useDeleteUptimeTokenMutation();

  useEffect(() => {
    deleteUptimeToken();
  }, [deleteUptimeToken]);

  useEffect(() => {
    if (isSuccess || isError) {
      globalThis.location.assign(composeUptimeLogoutUrl(returnUrl));
    }
  }, [isSuccess, isError, returnUrl]);

  return (
    <S.CenteredLoaderDiv>
      <Loader size="medium" variant="primary" />
    </S.CenteredLoaderDiv>
  );
};

export default UptimeLogoutContainer;
